import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import resultService from "../../services/result.service";


export const getresult = createAsyncThunk(
    "result/getResult",
    async (payload, thunkAPI) => {
        try {
            const response = await resultService.getResult(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const generateReportCard = createAsyncThunk(
    "result/generateReportCard",
    async (payload, thunkAPI) => {
        try {
            const response = await resultService.generateReportCard(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const addResult = createAsyncThunk(
    "result/addResult",
    async (data, thunkAPI) => {
        try {
            const response = await resultService.addResult(data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


const initialState = {
    loading: false,
    error: null,

    resultdata: [],

    selectedStaff: null,
    updateSuccess: false,
};


const resultSlice = createSlice({
    name: "result",
    initialState,

    reducers: {
        resetUpdateStatus: (state) => {
            state.updateSuccess = false;
        },
    },

    extraReducers: (builder) => {
        builder


            .addCase(getresult.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(getresult.fulfilled, (state, action) => {
                state.loading = false;
                state.resultdata = action.payload?.data || [];
            })

            .addCase(getresult.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});


export const { resetUpdateStatus } = resultSlice.actions;
export default resultSlice.reducer;
